module.exports = __webpack_public_path__ + "static/media/lwm.b4f22953.png";